import { memo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
interface Props {
  options: Highcharts.Options
}

const ChartArea = memo(({ options }: Props) => {
  return <HighchartsReact highcharts={Highcharts} options={options} />;
});
export default ChartArea;
